import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from '../styles.module.scss';

const PlayButton = ({
	isPlaying,
	play,
	rewindForward,
	rewindBack,
	theme = 'default',
	percentageProgress = 0
}) => {
	const handleChange = (event) => {
		switch (event.code) {
			case 'ArrowLeft':
				return rewindBack(event);
			case 'ArrowRight':
				return rewindForward(event);
			default:
				return play;
		}
	};

	const playTrack = (event) => {
		play(event);
	};

	const ariaLabel = isPlaying ? 'Пауза' : 'Воспроизвести';

	const renderProgressBar = () => {
		const circleSize = 44;
		const circleStrokeWidth = 2;
		const circleRadius = (circleSize - circleStrokeWidth) / 2;
		const circum = circleRadius * 2 * Math.PI;
		const circleProgress = 100 - percentageProgress;

		return (
			<div className={styles.PlayButton__WrapProgress}>
				<svg
					className={styles.PlayButton__SvgProgress}
					width={circleSize}
					height={circleSize}
				>
					<circle
						stroke="currentColor"
						fill="none"
						cx={circleSize / 2}
						cy={circleSize / 2}
						r={circleRadius}
						strokeDasharray={`${circum} ${circum}`}
						strokeDashoffset={
							circleRadius * Math.PI * 2 * (circleProgress / 100)
						}
						strokeLinecap="round"
						transform={`rotate(-90, ${circleSize / 2}, ${circleSize / 2})`}
						strokeWidth={circleStrokeWidth}
					/>
				</svg>
			</div>
		);
	};

	return (
		<button
			type="button"
			onClick={playTrack}
			onKeyDown={handleChange}
			className={cx(styles.PlayButton, {
				[styles.PlayButton_pauseStatus]: isPlaying,
				[styles.PlayButton_bordered]: theme === 'bordered',
				[styles.PlayButton_simpleButton]: theme === 'simpleButton'
			})}
			aria-label={ariaLabel}
		>
			<Icon
				className={cx(
					styles.PlayButton__Icon,
					isPlaying && styles.PlayButton__Icon_pause
				)}
				icon={isPlaying ? 'audio-pauseIcon' : 'audio-playIcon'}
				useClassName={PVI_NO_STYLES_CLASSNAME}
			/>
			{theme === 'simpleButton' && renderProgressBar()}
		</button>
	);
};

PlayButton.propTypes = {
	isPlaying: PropTypes.bool.isRequired,
	play: PropTypes.func.isRequired,
	rewindForward: PropTypes.func,
	rewindBack: PropTypes.func,
	theme: PropTypes.oneOf(['default', 'bordered', 'simpleButton']),
	percentageProgress: PropTypes.number
};

export default PlayButton;
